import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadService } from 'src/app/share/services/download.service';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';

@Component({
    selector: 'app-buyer-history',
    templateUrl: './buyer-history.component.html',
    styleUrls: ['./buyer-history.component.scss'],
    standalone: false
})
export class BuyerHistoryComponent implements OnChanges {

  @Input() selectedTyre: any;
  @Input() selectedRange: any;

  faAngleRight = faAngleRight;

  buyers: any = [];
  displayedBuyers: any = [];
  limit = 5;
  loader: boolean = false;
  errorMessage: string = '';

  constructor(
    private readonly modalService: NgbModal,
    private readonly ledgersService: LedgersService,
    private readonly downloadService: DownloadService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRange']?.currentValue) {
      this.getBuyersHistory();
    }
  }

  getBuyersHistory() {
    this.displayedBuyers = []
    this.buyers = []
    this.loader = true;
    let payload = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
      created_datefrom: this.selectedRange.startDate,
      created_dateupto: this.selectedRange.endDate,
    }
    this.ledgersService.getBuyerHistory(payload).subscribe({
      next: (res: any) => {
        this.loader = false;
        if (res.data.length) {
          this.mapData(res.data);
        } else {
          this.errorMessage = 'No Buyers history for this  filter';
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.errorMessage = err.error.message || 'Something went wrong';
      }
    })
  }

  mapData(data: any) {
    this.buyers = data.map((item: any) => ({
      dealerName: item.name?.trim() || '',
      quantity: Number.isNaN(Number(item.totalQuantity)) ? 0 : Number(item.totalQuantity),
      unitPrice: Number.isNaN(Number(item.perUnitPrice)) ? 0 : Number(item.perUnitPrice),
      purchaseFrequency: item.purchaseFrequency ? `${item.purchaseFrequency} Puchases in last ${this.selectedRange.period} days` : `No Puchases in last ${this.selectedRange.period} days`,
      date: item.lastPurchaseDate
        ? new Date(item.lastPurchaseDate).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Asia/Kolkata'
        })
        : ''
    }));
    this.displayedBuyers = this.buyers.slice(0, this.limit);
  }

  viewMore(content: any): void {
    this.modalService.open(content, { size: 'lg', scrollable: true, centered: true });
  }


  exportCSV() {
    let payload = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
      created_datefrom: this.selectedRange.startDate,
      created_dateupto: this.selectedRange.endDate,
    }
    const filename = `${this.selectedTyre.tyreSize}_${this.selectedTyre.tyreMake}_${this.selectedTyre.tyreModel}_buyers_history.csv`;
    const request: any = this.ledgersService.getBuyersHistoryCSV(payload);
    this.downloadService.download(request, filename);
  }

}
